module.exports = __webpack_public_path__ + "img/red_bull.1625d404.jpg";